module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/agency-1551c8920454e5855d843b269f3493b2.webp";